import { render, staticRenderFns } from "./GftFootnote.vue?vue&type=template&id=1cacd15c"
import script from "./GftFootnote.vue?vue&type=script&lang=ts"
export * from "./GftFootnote.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports